import gql from 'graphql-tag';

export const EHRENAMTLICHE_FINDEN_STEPS_FRAGMENT = gql`
  fragment ehrenamtlicheFindenSteps on EhrenamtlicheFindenStepsType {
    stepsTitle
    stepsText
    stepsDesktopImage
    stepsMobileImage
    stepsButtonText
    stepsButtonUrl
    id
  }
`;
